import { FavouriteBasketType } from '../../../../models/favourite-basket-type';
import client from '../../client';
import CultureCodeEnum from '../../../../models/culture-code-enum';

const favouritesCreate = async (
  catalogId: string,
  name: string,
  lineItems: { quantity: number; sku: string; variantSku: string }[] = []
): Promise<FavouriteBasketType[]> => {
  const { data } = await client.post<{ allBaskets: FavouriteBasketType[] }>(
    '/favourites/create',
    {
      name,
      cultureCode: CultureCodeEnum.EnGb,
      catalogId,
      lineItems,
    }
  );

  return data.allBaskets;
};

export default favouritesCreate;
